<div class="component-wrapper">
    <form class="form" (ngSubmit)="register()" [formGroup]="registrationForm">
        <div class="salutation">
            <kendo-formfield class="anrede">
                <kendo-label class="form-label" [for]="anrede"
                    text="{{'contact.salutation' | translate}}"></kendo-label>
                <kendo-combobox formControlName="anredeId" [valuePrimitive]="true" #anrede [allowCustom]="false"
                    [data]="anredeItems" [valueField]="'anredeId'" [textField]="'name'" kendoDropDownFilter>
                </kendo-combobox>
            </kendo-formfield>
            <kendo-formfield class="titel">
                <kendo-label class="form-label" [for]="akadtitel" text="{{'contact.title' | translate}}"></kendo-label>
                <kendo-combobox formControlName="titelId" [valuePrimitive]="true" #akadtitel [allowCustom]="false"
                    [data]="titelItems" [valueField]="'titelId'" [textField]="'name'" kendoDropDownFilter>
                </kendo-combobox>
            </kendo-formfield>
        </div>
        <div class="name">
            <div class="vorname">
                <kendo-formfield>
                    <kendo-label class="form-label" [for]="vorname"
                        text="{{'contact.firstName' | translate }} *"></kendo-label>
                    <kendo-textbox #vorname placeholder="{{'contact.firstName' | translate }}" formControlName="vorname"
                        showSuccessIcon="initial" showErrorIcon="initial"></kendo-textbox>
                    <kendo-formerror *ngFor="let errorMessage of vornameErrorMessages">{{errorMessage}}</kendo-formerror>
                </kendo-formfield>
            </div>
            <div class="nachname">
                <kendo-formfield>
                    <kendo-label class="form-label" [for]="nachname"
                        text="{{'contact.lastname' | translate }} *"></kendo-label>
                    <kendo-textbox #nachname placeholder="{{'contact.lastname' | translate }}"
                        formControlName="nachname" showSuccessIcon="initial" showErrorIcon="initial"></kendo-textbox>
                    <kendo-formerror *ngFor="let errorMessage of nachnameErrorMessages">{{errorMessage}}</kendo-formerror>
                </kendo-formfield>
            </div>
        </div>
        <kendo-formfield class="email">
            <kendo-label class="form-label" [for]="benutzername" text="{{'auth.email' | translate}} *"></kendo-label>
            <kendo-textbox #benutzername [readonly]="true" [disabled]="true" placeholder="{{'auth.email' | translate}}"
                formControlName="email"></kendo-textbox>
        </kendo-formfield>
        <div class="passwordContainer" *ngIf="isPasswordFieldVisible">
            <div class="password">
                <kendo-formfield>
                    <kendo-label class="form-label" [for]="password"
                        text="{{'register.password' | translate}} *"></kendo-label>
                    <kendo-textbox #password placeholder="{{'register.password' | translate}}"
                        formControlName="passwort" showSuccessIcon="initial" showErrorIcon="initial">
                        <ng-template kendoTextBoxSuffixTemplate>
                            <button type="button" kendoButton look="clear"
                                (click)="toggleVisibility(this.passwordTextBox)" [title]="'toggle.password.visibility' | translate">
                                <kendo-svg-icon [icon]="icons.eye"></kendo-svg-icon></button>
                        </ng-template>
                    </kendo-textbox>
                    <kendo-formerror *ngFor="let errorMessage of passwortErrorMessages">{{errorMessage}}</kendo-formerror>
                </kendo-formfield>
            </div>

            <div class="passwordW">
                <kendo-formfield>
                    <kendo-label class="form-label" [for]="passwordW"
                        text="{{'register.repeatPassword' | translate}} *"></kendo-label>
                    <kendo-textbox #passwordW placeholder="{{'register.repeatPassword' | translate}}"
                        formControlName="passwortWiederholen" showSuccessIcon="initial" showErrorIcon="initial">
                        <ng-template kendoTextBoxSuffixTemplate>
                            <button type="button" kendoButton look="clear"
                                (click)="toggleVisibility(this.passwordWiederholenTextBox)" [title]="'toggle.password.visibility' | translate">
                                <kendo-svg-icon [icon]="icons.eye"></kendo-svg-icon></button>
                        </ng-template>
                    </kendo-textbox>
                    <kendo-formerror *ngFor="let errorMessage of passwortWiederholenErrorMessages">{{errorMessage}}</kendo-formerror>
                </kendo-formfield>
            </div>
        </div>
        <div class="datenschutz">
            <kendo-formfield>
                <div class="k-checkbox-wrap">
                    <input id="datenschutz" #datenschutz type="checkbox" kendoCheckBox formControlName="datenschutz"/>
                    <label for="datenschutz" class="k-checkbox-label"
                        [innerHTML]="'pre-register.privacyAgreement' | translate:{linkDatenschutzbestimmung}">
                    </label>
                </div>
                <kendo-formerror *ngFor="let errorMessage of datenschutzErrorMessages">{{errorMessage}}</kendo-formerror>
            </kendo-formfield>
        </div>

        <captcha-component formControlName="captchaChallengeResponse"></captcha-component>

        <div class="submit-wrapper">
            <button kendoButton class="registrieren" type="submit" [disabled]="isRegistrationButtonDisabled"
                [innerHTML]="'register.register' | translate">
            </button>
        </div>
    </form>
</div>